import { Camera } from './Camera';
import { ImagePreview } from './ImagePreview';

import { CAMERA_STEP, useCameraContext } from '~providers/CameraProvider';

export const CameraComponent: React.FC = () => {
  const { cameraStep, isCameraOpen } = useCameraContext();

  return (
    <>
      {isCameraOpen && (
        <Camera isVisible={cameraStep === CAMERA_STEP.CAPTURE} />
      )}
      <ImagePreview isVisible={cameraStep === CAMERA_STEP.PREVIEW} />
    </>
  );
};
